import { Box, Container, FloraProvider, Heading } from '@grupoboticario/flora-react'
import { useTranslation } from 'react-i18next'

const InvalidUUID = () => {
  const { t } = useTranslation()

  return (
    <FloraProvider>
      <Box
        css={{
          '@tablet': {
            width: 600
          },
          margin: '2rem auto',
          width: '100%',
          gap: '$2'
        }}
      >
        <Container centerContent size="large">
          <Heading level={3} as="h1">
            {t('invalidCode')}
          </Heading>
          <Heading level={5} as="h2" css={{ display: 'block', marginTop: '20px' }}>
            {t('invalidMsg')}
          </Heading>
        </Container>
      </Box>
    </FloraProvider>
  )
}

export default InvalidUUID
